"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSegmentationHeaders = void 0;
var _react = require("react");
var _utils = require("../utils");
/**
 * Hook variant of `getSegmentationHeaders` function with auto aborts and error handling.
 *
 *  @deprecated Use `HeadersProvider` with `useHeaders` instead.
 */
const useGetSegmentationHeaders = ({
  sourceAppName,
  atpClusterId,
  language,
  customerId,
  globalApiUrl,
  staticApiUrl,
  tenant,
  token,
  useProductDataCaching,
  useProductsService
}) => {
  const [error, setError] = (0, _react.useState)();
  const [headers, setHeaders] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    (0, _utils.getSegmentationHeaders)({
      abortController,
      sourceAppName,
      atpClusterId,
      language,
      staticApiUrl,
      customerId,
      globalApiUrl,
      tenant,
      token,
      useProductDataCaching,
      useProductsService
    }).then(setHeaders).catch(setError);
    return () => abortController.abort();
  }, [sourceAppName, atpClusterId, language, customerId, staticApiUrl, globalApiUrl, tenant, token, useProductDataCaching, useProductsService]);
  return (0, _react.useMemo)(() => ({
    error,
    loading: error === undefined && headers === undefined,
    headers
  }), [error, headers]);
};
exports.useGetSegmentationHeaders = useGetSegmentationHeaders;
